import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Component } from 'react';
import { color } from '../../app/theme';
import icEdit from '../../assets/images/svg/ic-edit.svg';
import TextField from './TextField';

const useStyles = theme => ({
  subheading: theme.typography.subheading,
  infoContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0',
  },
  blurText: {
    padding: '0px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    height: '38px',
    width: '100%',
    '&:hover': {
      backgroundColor: color.$8,
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  focusText: {
    padding: '0px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    height: '38px',
    width: '100%',
  },
  input: {
    ...theme.typography.subheading,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
});

class SavingTextField extends Component {
  constructor() {
    super();
    this.state = { focus: false, endIconShow: false };
  }

  renderEndAdorment() {
    const { endIconShow } = this.state;
    if (!endIconShow) {
      return null;
    }
    return (
      <img
        alt="displayName"
        style={{ objectFit: 'contain', cursor: 'pointer', marginRight: '8px' }}
        src={icEdit}
        width={24}
        height={24}
      />
    );
  }

  render() {
    const {
      classes,
      placeholder,
      type,
      value,
      onChange,
      select,
      MenuItems,
      SelectProps,
      InputProps,
      multiline,
      rowsMax,
      style,
      rows,
      className,
      placeholderClass,
      onBlur,
    } = this.props;
    const { focus } = this.state;
    const TextClass = focus ? classes.focusText : classes.blurText;
    return (
      <div>
        <div
          onMouseEnter={() => {
            this.setState({ endIconShow: true });
          }}
          onMouseLeave={() => {
            this.setState({ endIconShow: false });
          }}
          onMouseDown={() => {
            this.setState({ endIconShow: false });
          }}
        >
          <TextField
            inputRef={el => {
              this.savingTextFieldRef = el;
            }}
            isValid
            className={classNames([TextClass, className])}
            style={style}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
            multiline={multiline}
            rows={rows}
            rowsMax={rowsMax}
            InputProps={{
              onFocus: () => {
                this.setState({ focus: true });
              },
              onBlur: () => {
                this.setState({ focus: false }, () => {
                  if (onBlur) {
                    onBlur();
                  }
                });
              },
              onKeyPress: e => {
                if (e.key === 'Enter') {
                  this.savingTextFieldRef.blur();
                }
              },
              endAdornment: this.renderEndAdorment(),
              classes: {
                input: classNames([classes.input, placeholderClass]),
              },
              ...InputProps,
            }}
            select={select}
            MenuItems={MenuItems}
            SelectProps={SelectProps}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SavingTextField);
